/* ==========================================================================
   Bold Movement — Bundle Upgrade Modal
   Triggered after Quick Add. Lets shopper pick a bundle mix and ATC it,
   OR add the single they originally wanted. After either action, the cart
   drawer opens. Lives entirely outside the cart-drawer DOM space.
   ========================================================================== */

(function () {
  'use strict';

  var modal = document.querySelector('[data-bum]');
  var configEl = document.getElementById('bm-upgrade-modal-config');
  if (!modal || !configEl) return;

  var config;
  try { config = JSON.parse(configEl.textContent); } catch (e) { return; }
  if (!config.tiers || !config.tiers.length) return;

  config.tiers.forEach(function (t) {
    if (typeof t.price === 'string') t.price = parseInt(t.price, 10);
    if (isNaN(t.price)) t.price = 0;
  });
  var sortedTiers = config.tiers.slice().sort(function (a, b) { return b.size - a.size; });
  var SOLO_CENTS = config.soloCents || 2500;

  var COLOR_NAMES = { aegean: 'Aegean Blue', onyx: 'Onyx Black', artemis: 'Artemis Red' };
  var COLOR_ORDER = ['aegean', 'onyx', 'artemis'];

  var variantToColor = {};
  var productIdToColor = {};
  var handleToColor = {};
  COLOR_ORDER.forEach(function (c) {
    var solo = config.solos && config.solos[c];
    if (!solo) return;
    if (solo.variantId) variantToColor[String(solo.variantId)] = c;
    if (solo.productId) productIdToColor[String(solo.productId)] = c;
    if (solo.handle) handleToColor[solo.handle] = c;
  });

  var state = {
    mix: { aegean: 0, onyx: 0, artemis: 0 },
    triggerForm: null,
    triggerBtn: null,
    triggerColor: 'aegean',
    triggerQty: 1
  };

  function money(cents) {
    var n = cents / 100;
    return '$' + (Math.round(n * 100) / 100).toFixed(2).replace(/\.00$/, '');
  }
  function moneyExact(cents) { return '$' + (cents / 100).toFixed(2); }

  function totalQty() {
    return state.mix.aegean + state.mix.onyx + state.mix.artemis;
  }

  function decompose(n) {
    var out = [];
    var remaining = n;
    sortedTiers.forEach(function (t) {
      while (remaining >= t.size) {
        out.push(t);
        remaining -= t.size;
      }
    });
    if (remaining > 0) return null;
    return out;
  }

  function planLabel(parts) {
    if (!parts || !parts.length) return '';
    if (parts.length === 1) return parts[0].size + '-Pack';
    var counts = {};
    parts.forEach(function (p) { counts[p.size] = (counts[p.size] || 0) + 1; });
    return Object.keys(counts).map(Number).sort(function (a, b) { return b - a; }).map(function (size) {
      var c = counts[size];
      return c > 1 ? c + '× ' + size + '-Pack' : size + '-Pack';
    }).join(' + ');
  }

  function smartMix(anchor, total) {
    var mix = { aegean: 0, onyx: 0, artemis: 0 };
    if (total <= 0) return mix;
    mix[anchor] = 1;
    var remaining = total - 1;
    if (remaining <= 0) return mix;
    var others = COLOR_ORDER.filter(function (c) { return c !== anchor; });
    var seq = [others[0], others[1], anchor];
    var idx = 0;
    while (remaining > 0) {
      mix[seq[idx % seq.length]] += 1;
      remaining -= 1;
      idx += 1;
    }
    return mix;
  }

  function detectColorFromForm(form) {
    var idInput = form.querySelector('[name="id"]');
    if (idInput) {
      var vid = idInput.value;
      if (variantToColor[String(vid)]) return variantToColor[String(vid)];
    }
    var action = (form.action || '') + '';
    for (var c in handleToColor) {
      if (action.indexOf(c) >= 0) return handleToColor[c];
    }
    return null;
  }

  var $chip = modal.querySelector('[data-bum-chip]');
  var $save = modal.querySelector('[data-bum-save]');
  var $sub = modal.querySelector('[data-bum-sub]');
  var $trigger = modal.querySelector('[data-bum-trigger]');
  var $trigger2 = modal.querySelector('[data-bum-trigger2]');
  var $was = modal.querySelector('[data-bum-was]');
  var $now = modal.querySelector('[data-bum-now]');
  var $final = modal.querySelector('[data-bum-final]');
  var $primary = modal.querySelector('[data-bum-upgrade]');
  var $primaryLabel = modal.querySelector('[data-bum-primary-label]');
  var $secondaryLabel = modal.querySelector('[data-bum-secondary-label]');

  function setCount(color, n) {
    var el = modal.querySelector('[data-bum-count="' + color + '"]');
    if (el) el.textContent = n;
    var row = modal.querySelector('[data-bum-row="' + color + '"]');
    if (row) row.classList.toggle('has-count', n > 0);
    var minus = modal.querySelector('[data-bum-minus="' + color + '"]');
    if (minus) minus.disabled = n === 0;
  }

  function render() {
    var n = totalQty();
    var parts = n >= 2 ? decompose(n) : null;

    if (!parts) {
      if ($primary) $primary.disabled = true;
      if ($primaryLabel) $primaryLabel.textContent = 'Pick at least 2 pairs';
      COLOR_ORDER.forEach(function (c) { setCount(c, state.mix[c]); });
      return;
    }
    if ($primary) $primary.disabled = false;

    var bundleSubtotal = parts.reduce(function (s, p) { return s + p.price; }, 0);
    var soloEquivalent = n * SOLO_CENTS;
    var savings = Math.max(0, soloEquivalent - bundleSubtotal);
    var finalAfter = Math.round(bundleSubtotal * (1 - (config.discountPercent || 0) / 100));

    // Shorter chip label for multi-bundle combos so it doesn't wrap
    var chipLabel;
    if (parts.length === 1) {
      chipLabel = planLabel(parts); // e.g. "2-Pack"
    } else if (parts.length === 2 && parts[1].size === 1) {
      chipLabel = parts[0].size + '-Pack + 1'; // e.g. "4-Pack + 1"
    } else {
      chipLabel = n + ' Pairs Bundle';
    }
    if ($chip) $chip.textContent = 'Smart Upgrade · ' + chipLabel;
    if ($save) {
      if (savings > 0) { $save.textContent = 'Save ' + moneyExact(savings); $save.hidden = false; }
      else { $save.hidden = true; }
    }
    if ($was) {
      if (savings > 0) { $was.textContent = money(soloEquivalent); $was.hidden = false; }
      else { $was.hidden = true; }
    }
    if ($now) $now.textContent = money(bundleSubtotal);
    if ($final) $final.textContent = money(finalAfter);
    if ($primaryLabel) {
      // Use the shorter chip label for the button too, otherwise it wraps on mobile
      $primaryLabel.textContent = 'Upgrade — ' + n + ' pairs · ' + money(bundleSubtotal) + ' →';
    }

    COLOR_ORDER.forEach(function (c) { setCount(c, state.mix[c]); });
  }

  function show(form, btn) {
    var color = detectColorFromForm(form);
    if (!color) return false;

    state.triggerForm = form;
    state.triggerBtn = btn || null;
    state.triggerColor = color;

    var qtyInput = form.querySelector('[name="quantity"]');
    state.triggerQty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;

    state.mix = smartMix(color, 2);

    var name = COLOR_NAMES[color];
    if ($trigger) $trigger.textContent = name;
    if ($trigger2) $trigger2.textContent = name;
    if ($sub) {
      $sub.innerHTML = 'You picked <strong>' + name + '</strong>. Pair it with a 2nd colorway and save.';
    }
    if ($secondaryLabel) {
      $secondaryLabel.textContent = 'Just add 1× ' + name + ' — $25';
    }

    render();
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    void modal.offsetHeight;
    requestAnimationFrame(function () { modal.classList.add('is-visible'); });
    return true;
  }

  function close() {
    modal.classList.remove('is-visible');
    document.body.style.overflow = '';
    setTimeout(function () { modal.hidden = true; }, 320);
  }

  modal.querySelectorAll('[data-bum-plus]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var c = btn.getAttribute('data-bum-plus');
      if (!(c in state.mix)) return;
      state.mix[c] += 1;
      render();
    });
  });
  modal.querySelectorAll('[data-bum-minus]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var c = btn.getAttribute('data-bum-minus');
      if (!(c in state.mix) || state.mix[c] <= 0) return;
      state.mix[c] -= 1;
      render();
    });
  });

  modal.querySelectorAll('[data-bum-close]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      close();
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) close();
  });

  function refreshCartDrawer(resp) {
    if (resp && resp.sections && resp.sections['cart-drawer']) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(resp.sections['cart-drawer'], 'text/html');
        var newCD = doc.querySelector('cart-drawer');
        var newInner = newCD ? newCD.querySelector('#CartDrawer') : doc.querySelector('#CartDrawer');
        var oldInner = drawer.querySelector('#CartDrawer');
        if (newInner && oldInner) oldInner.replaceWith(newInner);
        drawer.classList.remove('is-empty');
      }
    }
    if (resp && resp.sections && resp.sections['cart-icon-bubble']) {
      var bubble = document.querySelector('#cart-icon-bubble');
      if (bubble) bubble.innerHTML = resp.sections['cart-icon-bubble'];
    }
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
  }

  modal.querySelector('[data-bum-single]').addEventListener('click', function (e) {
    e.preventDefault();
    if (!state.triggerForm) { close(); return; }
    var form = state.triggerForm;

    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer,cart-icon-bubble');

    close();

    fetch('/cart/add.js', {
      method: 'POST',
      body: fd,
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function (resp) {
        return fetch('/?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (sections) {
          refreshCartDrawer({ sections: sections });
          openCartDrawer();
        });
      })
      .catch(function () { window.location.href = '/cart'; });
  });

  $primary.addEventListener('click', function (e) {
    e.preventDefault();
    var n = totalQty();
    var parts = decompose(n);
    if (!parts) return;

    var pool = [];
    COLOR_ORDER.forEach(function (c) {
      for (var i = 0; i < state.mix[c]; i++) pool.push(c);
    });

    var items = [];
    parts.forEach(function (part) {
      var take = pool.splice(0, part.size);
      var local = {};
      take.forEach(function (c) { local[c] = (local[c] || 0) + 1; });

      if (part.size === 1) {
        var color = Object.keys(local)[0];
        var vid = config.solos && config.solos[color] && config.solos[color].variantId;
        if (vid) items.push({ id: Number(vid), quantity: 1 });
      } else {
        if (!part.variantId) return;
        var colorString = COLOR_ORDER
          .filter(function (c) { return local[c] > 0; })
          .map(function (c) { return local[c] + '× ' + COLOR_NAMES[c]; })
          .join(' · ');
        items.push({
          id: Number(part.variantId),
          quantity: 1,
          properties: { 'Colors': colorString, 'Bundle': part.size + '-pack' }
        });
      }
    });

    if (!items.length) return;

    $primary.disabled = true;
    if ($primaryLabel) $primaryLabel.textContent = 'Adding…';

    var fd = new FormData();
    items.forEach(function (it, i) {
      fd.append('items[' + i + '][id]', it.id);
      fd.append('items[' + i + '][quantity]', it.quantity);
      if (it.properties) {
        Object.keys(it.properties).forEach(function (k) {
          fd.append('items[' + i + '][properties][' + k + ']', it.properties[k]);
        });
      }
    });
    fd.append('sections', 'cart-drawer,cart-icon-bubble');

    fetch('/cart/add.js', {
      method: 'POST',
      body: fd,
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function (resp) {
        refreshCartDrawer(resp);
        close();
        setTimeout(openCartDrawer, 200);
      })
      .catch(function () { window.location.href = '/cart'; });
  });

  window.BM_UPGRADE_MODAL = {
    shouldIntercept: function (form) {
      if (!form) return false;
      var idInput = form.querySelector('[name="id"]');
      if (!idInput) return false;
      var vid = String(idInput.value);
      return !!variantToColor[vid];
    },
    show: function (form, btn) {
      return show(form, btn);
    }
  };
})();
